// =====================================================================
// LAS REGLAS DE LAS PANTALLAS DE LLAVES · DIRECTRIZ-LLAVE L-3
// =====================================================================
// Fuera de los componentes, en JS puro: las usan Mi cuenta, la ficha de
// Personal y sus pruebas, y así se prueban sin montar nada.

export function fechaDeLlave(valor) {
  if (!valor) return null;
  try { return new Date(valor).toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' }); } catch { return String(valor); }
}

export function tipoDeLlave(adjunto) {
  if (adjunto === 'platform') return 'Guardada en el aparato';
  if (adjunto === 'cross-platform') return 'Llave física (USB o NFC)';
  return null;
}

/** El texto de la confirmación de «Quitar», según sea o no la última. */
export function consecuenciaDeQuitar(llave, quedan, pideCodigo) {
  if (quedan <= 1) {
    return pideCodigo === false
      ? 'Es tu última llave: volverás a entrar solo con tu contraseña.'
      : 'Es tu última llave: volverás a entrar solo con tu contraseña y el código de tu autenticador.';
  }
  return `Ya no podrás entrar con esta llave desde ${llave.aparato || 'ese aparato'}.`;
}

export const MINIMO_MOTIVO = 10;

/** Lo que todavía impide quitar la llave, dicho en una frase; '' si nada. */
export function faltaDelMotivo(motivo) {
  const n = (motivo || '').trim().length;
  if (n >= MINIMO_MOTIVO) return '';
  if (n === 0) return `escribe el motivo (mínimo ${MINIMO_MOTIVO} letras)`;
  const faltan = MINIMO_MOTIVO - n;
  return `escribe ${faltan} ${faltan === 1 ? 'letra' : 'letras'} más en el motivo (mínimo ${MINIMO_MOTIVO})`;
}

/** Solo el Admin Supremo, y no sobre sí mismo (lo suyo está en Mi cuenta). */
export function veLlavesDeOtros(yo, persona) {
  return yo?.rol === 'DUENO' && !!persona && persona.id !== yo.id && persona.rol !== 'DISPOSITIVO';
}

